import FloatingVue from 'floating-vue'
// Notifications plugin
import Notifications from 'src/components/NotificationPlugin'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from './components/SidebarPlugin'
// bootstrap.css is loaded by assets/css/vuetify-layers.css (imported in main.js) inside a CSS layer below Vuetify 4
import 'floating-vue/dist/style.css'
import './assets/sass/light-bootstrap-dashboard.scss'
import './assets/css/layout-restore.css'
// Bootstrap 5's JS imports @popperjs/core itself (Bootstrap 4 needed popper.js v1 and jQuery)
import 'bootstrap/dist/js/bootstrap.js'

/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
export default {
  install(app) {
    app.use(FloatingVue);
    app.use(GlobalComponents);
    app.use(GlobalDirectives);
    app.use(SideBar);
    app.use(Notifications);
  }
}
